import React from 'react';

/**
 * inline(text) — renders a minimal inline-markdown subset as React nodes.
 * Supported: **bold**, `code`, [label](url)
 * Zero dependencies, no dangerouslySetInnerHTML.
 * Patterns are non-nested (a `code` span won't also parse **bold** inside it) —
 * that's intentional and plenty for help copy.
 */
export function inline(text) {
  if (text == null || text === '') return null;
  const src = String(text);
  const nodes = [];
  let key = 0;
  let last = 0;

  // Order in the alternation = match priority: bold, code, link.
  const re = /(\*\*([^*]+)\*\*)|(`([^`]+)`)|(\[([^\]]+)\]\(([^)\s]+)\))/g;
  let m;
  while ((m = re.exec(src)) !== null) {
    if (m.index > last) nodes.push(src.slice(last, m.index));

    if (m[2] !== undefined) {
      nodes.push(
        <strong key={key++} style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{m[2]}</strong>
      );
    } else if (m[4] !== undefined) {
      nodes.push(<code key={key++} className="pb-code">{m[4]}</code>);
    } else if (m[6] !== undefined) {
      nodes.push(
        <a key={key++} href={m[7]} target="_blank" rel="noopener noreferrer">{m[6]}</a>
      );
    }
    last = re.lastIndex;
  }
  if (last < src.length) nodes.push(src.slice(last));
  return nodes;
}
